module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAAS0lEQVQ4y2P4jwQ+MAww7wADDNgPCt7/A/z//w8GHoiBcNnA8hiYgY76D3fngPKALoMKDQLeH2AIIWJsoHmoLhtA3oDnYgRv8JR1AMwsximv+8vDAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI3OjA5KzA5OjAwtvXhfwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00631_100x100.png
// module id = 3ECg
// module chunks = 0